<template>
  <div class="search__input-wrapper">
    <div class="search__input-container search-input">
      <input
        @input="handleInput"
        :value="searchQuery"
        :placeholder="placeholder"
        ref="searchInput"
        type="text"
        class="search-input__input"
      />
      <button
        v-show="searchQuery"
        @click="handleReset"
        class="search-input__reset cross"
        type="button"
        aria-label="Reset input query"
      ></button>
    </div>
  </div>
</template>

<script>
import { debounce } from "../../utils/performance";

export default {
  name: "searchBar",
  components: {},
  props: {
    searchQuery: {
      type: String,
    },
    queryParams: {},
    queryParamKey: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    submitButtonLabel: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    handleInput: debounce(function(e) {
      this.updateSearchQuery(e.target.value);
    }, 400),
    handleReset() {
      this.focusSearchInput();
      this.updateSearchQuery("");
    },
    updateFilter() {
      const args = {
        search: {
          value: this.searchQuery,
          queryParamKey: this.queryParamKey,
        },
      };

      this.$emit("updateFilter", args);
    },
    focusSearchInput() {
      this.$refs.searchInput.focus();
    },
    updateSearchQuery(value) {
      this.$emit("updateSearchQuery", value);
    },
    setDefaultState() {
      if (!this.queryParamKey) return;

      const queryParamValue = this.$getQueryParamValueByKey(this.queryParams, this.queryParamKey);

      if (!queryParamValue) return;

      this.$emit("updateSearchQuery", queryParamValue);
    },
  },
  mounted() {
    this.setDefaultState();
  },
  watch: {
    searchQuery: function() {
      this.updateFilter();
    },
  },
};
</script>
